import React, {
    useEffect,
    useLayoutEffect,
    useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import Check from 'assets/images/icon/Check';
import CloseIcon from 'assets/images/icon/CloseIcon';
import MyIcon from 'assets/images/icon/DropdownIcon';
import PlusIcon from 'assets/images/icon/PlusIcon';
import useGetClassData from 'hooks/useGetClassData';
import {
    cloneDeep,
} from 'lodash';
import {
    useLocation,
    useNavigate,
} from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import {activeSubmit, Alert} from 'state';
import styled from 'styled-components';
import {
    DropdownMenu,
    Overlay,
} from 'view/components';
import Popup from 'view/pages/Create/components/Popup';
import {returnChapterId} from "../../../../../constants";
import EyeIcon from "../../../../../assets/images/icon/EyeIcon";
import EyeOpen from "../../../../../assets/images/icon/EyeOpen";
import { isEmpty } from 'util/isEmpty';
import {fadeIn} from "../../../../../styled/StyledComponent";

const db = [
    {
        id: 331,
        category: "Introduction",
        chapterTitle: "chaptertitlez",
        jwPlayerList: [
            { id: 324, preview: true, title: "cv", fileName: "test_file.mp4", deleted: false },
        ],
    },
    {
        id: 332,
        category: "Chapter 1",
        chapterTitle: "chaptertitle1",
        jwPlayerList: [
            {
                id: 317,
                preview: false,
                title: "title12",
                fileName: "test_file.mp4",
                deleted: false,
            },
        ],
    },
    { category: "Chapter 2", chapterTitle: "ds", jwPlayerList: [] },
];

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
}

const chapterStructure = {
    chapterType: "",
    chapterTitle: "",
    orderNumber:0,
    jwPlayerList: [],
};

const quizStructure = {
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
    correct1: false,
    correct2: false,
    correct3: false,
    correct4: false,
    explanation1: "",
    explanation2: "",
    explanation3: "",
    explanation4: "",
    question: "",
    relateVideos: 0,
};

const structure = {
    newQuizList: [
        {
            chapterId: 0,
            quizList: [],
        },
    ],
};
const Quiz = () => {
    const {
        state: { createId },
    } = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { data: classesData, stepData } = useGetClassData(
        createId,
        "getClassChapterById",
        isLoading
    );
    const { data: classes, stepData: chapterItems } = useGetClassData(
        createId,
        "getClassVideoById",
        isLoading,
    );
    const setSubmit = useSetRecoilState(activeSubmit);
    const [quizData, setQuizData] = useState(
        structure?.newQuizList?.map((item) => {
            return {
                ...item,
            };
        })
    );
    const [chapterData, setChapterData] = useState(["", ""]);
    const [selectChapter, setSelectChapter] = useState("");
    const [selectedata, setSelectedData] = useState({ id: "", chapterTitle: "", chapterType: "" });
    const [chapter, setChapter] = useState([chapterStructure]);
    const [newQuizList, setNewQuizList] = useState(null);
    const [onPopup, setOnPopup] = useState(false);
    const [chapterTitle, setChapterTitle] = useState("");
    const [chapterCategory, setChapterCategory] = useState("");
    const [listIndex, setListIndex] = useState([]);
    const [foldIndex, setFoldIndex] = useState([])
    const setAlert = useSetRecoilState(Alert)

    const onClickDropDown = (item: any, state: any, index: any, s: any) => {
        setSelectChapter(item);
        setSelectedData(s);
    };

    const getFormData = (data) => {
        console.log("@dt",data);
        const formData = new FormData();
        // const copy = cloneDeep(data)?.map((item) => {
        //     item.jwPlayerList = item?.jwPlayerList?.filter((item) => {
        //         return !isEmpty(item?.id);
        //     });
        //     return item;
        // });

        // copy?.forEach((item, index) => {
        //     Object.entries(item).forEach((chItem) => {
        //         if(chItem[0] === "jwPlayerList"){
        //             // @ts-ignore
        //             [...chItem[1]].forEach((jwItem, jwIndex) => {
        //                 Object.entries(jwItem).forEach((fItem, fIndex) => {
        //                     if(fItem[0] !== "deleted" && fItem[0] !== "playTime"){
        //                         formData.append(`newChapters[${index}].jwPlayerList[${jwIndex}].${fItem[0]}`,String(fItem[1]))
        //                     }
        //                 })
        //             })
        //         }else{
        //             formData.append(`newChapters[${index}].${chItem[0]}`,String(chItem[1]))
        //         }
        //     })
        // })

        const copy = cloneDeep(data)?.map(item => {
            item.jwPlayerList = item?.jwPlayerList?.filter(item => {
                return !isEmpty(item?.id);
            });
            // item.chapterType = returnChapterId(item?.chapterTitle)?.chapterType;
            item.chapterType = item?.chapterType;
            item.orderNumber = returnChapterId(item?.chapterType)?.orderNumber || 0;
            if(isEmpty(item.id)){
                delete item.id;
            };
            return item;
        });
        formData.append("newChapters",JSON.stringify({chapters:cloneDeep(copy)}))

        return formData;
    };

    console.log("chapterItems", chapterItems);
    const putVideoData = async (data) => {
        console.log("data2", data);
        setIsLoading(true)
        await classesAPI
            .putClassVideo(createId, {
                data: getFormData(data),
            })
            .then((res) => {
                console.log("upload", res);
                setIsLoading((v) => !v);
                setOnPopup(false);
                dataSet();
                setIsLoading(false)
            });
    };

    const dataSet = () => {
        const mapData = cloneDeep(stepData)?.map((item) => {
            return {
                ...item,
                dropdownItem: item?.category,
            };
        });
        setChapterData(cloneDeep(mapData));
    };

    useLayoutEffect(() => {
        if (!isEmpty(stepData)) {
            const mapData = cloneDeep(stepData)?.map((item) => {
                return {
                    ...item,
                    dropdownItem: item?.category,
                };
            });
            setChapterData(cloneDeep(mapData));
        }
    }, [stepData]);

    useLayoutEffect(() => {
        if (!isEmpty(chapterItems?.chapters)) {
            const mapData = cloneDeep(chapterItems?.chapters)?.map((item) => {
                const viedoData = [
                    {
                        id: "",
                        title: "",
                        fileName: "",
                        preview: false,
                    },
                ];
                return {
                    id: item?.id,
                    chapterType:item?.category,
                    chapterTitle: item?.chapterTitle,
                    orderNumber:item?.orderNumber,
                    jwPlayerList:
                        cloneDeep(item?.videos).length === 0 ? viedoData : cloneDeep(item?.videos),
                    quiz: item.quizList,
                };
            });
            setChapter(cloneDeep(mapData));
            setNewQuizList(cloneDeep(chapterItems));
            setSelectChapter(chapterItems?.chapters[0]?.category);
            setSelectedData(
                { id: chapterItems?.chapters[0]?.id, chapterTitle: chapterItems?.chapters[0]?.chapterTitle,
                    chapterType: chapterItems?.chapters[0]?.category }
            );

        }
    }, [chapterItems]);

    console.log("@chapterItems",chapterItems);
    const onClickFoldChapter = (id?:any) => {
        const c = [...foldIndex];
        const check = c.findIndex(item => {
            return item === id;
        })
        if(check !== -1){
            c.splice(check,1);
        }else{
            c.push(id)
        }
        setFoldIndex(c);
    }

    useEffect(() => {
        document.addEventListener("click", () => {
            setOnPopup(false);
        });
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", function (event) {
            const keyCode = event.keyCode || event.which;
            const key = event.key;
            if (keyCode === 27 || key === "Escape") {
                setOnPopup(false);
            }
        });
    }, []);
    // @ts-ignore
    console.log("@check",chapter?.length == 1 && isEmpty(chapter?.find((item) => item?.id)));
    const setChapterList = async (isAdd: boolean, index?: number, chapter?:any) => {
        console.log("@chapter2",chapter);
        const copyData = cloneDeep(chapter);
        await putQuiz(false);
        if (isAdd) {
            if (chapterTitle == "") {
                alert("Please enter a title");
                return;
            }
            if (chapterCategory == "") {
                alert("Please enter a category");
                return;
            }
            // @ts-ignore
            copyData.push({
                chapterType: chapterCategory,
                chapterTitle: chapterTitle,
                orderNumber:returnChapterId(chapterCategory).orderNumber,
                jwPlayerList: [],
            });
            setChapter(copyData);
            console.log("@c1",copyData);
            await putVideoData(copyData);
        } else {
            const c = copyData.splice(index, 1);
            setChapter(copyData);
            await putVideoData(c);
        }

    };
    console.log("@chapter",chapter);
    //chapter패칭 데이터 기준으로 /video사용 챕터 추가, add quiz chapter가공 후 putquiz

    const onChangeTitle = (value: string) => {
        setChapterTitle(value);
    };

    const onChangeCategory = (value?: any) => {
        setChapterCategory(value);
    };

    console.log("@quizData",newQuizList);
    const getQuizList = (chapterId: any) => {
        if (isEmpty(chapter)) return quizData;
        const copy = cloneDeep(newQuizList);
        console.log("copy", copy);
        const findItem = copy?.chapters?.filter((item) => item.id === chapterId);
        if (isEmpty(findItem)) {
            return quizData;
        }
        const t = findItem.map((item) => {
            return {
                ...item,
                quizList: item.quizList.map((quizItem) => {
                    return {
                        ...quizItem,
                        fold: false,
                    };
                }),
            };
        });
        console.log("t", t);
        return copy?.chapters;
    };

    const onChangeQuizItem = (chapterId, quizIndex, target, value) => {
        console.log("test", chapterId);
        const copy = cloneDeep(newQuizList);
        const index = copy?.chapters?.findIndex((item) => item.id === chapterId);
        console.log("test", index);
        copy.chapters[index].quizList[quizIndex][target] = value;
        setNewQuizList(cloneDeep(copy));
    };
    // quizStructure

    const addQuiz = (chapterId) => {
        // if (!isEmpty(chapterId)) return;
        const copy = cloneDeep(newQuizList);
        const index = copy?.chapters?.findIndex((item) => item.id === chapterId);
        console.log("copy2", copy.chapters, index);
        copy.chapters[index].quizList.push(quizStructure);
        setNewQuizList(cloneDeep(copy));
    };

    const onClickDeleteChapter = async (id) => {
        await putQuiz(false);
        await putVideoData(chapter)
        await classesAPI.deleteClassChapter(createId,id, null)
            .then(res => {
                console.log('suc', res)

                const mapData = cloneDeep(res?.data?.chapters)?.map((item) => {
                    const videoData = [
                        {
                            id: "",
                            title: "",
                            fileName: "",
                            preview: false,
                        },
                    ];
                    return {
                        id: item?.id,
                        chapterType:item?.category,
                        chapterTitle: item?.chapterTitle,
                        orderNumber:item?.orderNumber,
                        jwPlayerList:
                            cloneDeep(item?.videos).length === 0 ? videoData : cloneDeep(item?.videos),
                        quiz: item.quizList,
                    };
                });
                setChapter(cloneDeep(mapData));
                setNewQuizList(cloneDeep(res?.data));
                setSelectChapter(res?.data?.chapters[0]?.category);
                setSelectedData(
                    { id: res?.data?.chapters[0]?.id, chapterTitle: res?.data?.chapters[0]?.chapterTitle,
                        chapterType: res?.data?.chapters[0]?.category }
                );
            })
    }
    const removeQuiz = (chapterId, quizIndex) => {
        const copy = cloneDeep(newQuizList);
        const index = copy?.chapters?.findIndex((item) => item.id === chapterId);
        copy.chapters[index].quizList.splice(quizIndex,1)
        setNewQuizList(cloneDeep(copy));
    }

    const onClickAddIndex = (index, list) => {
        const d = [...list];
        const check = list.findIndex((item) => item === index);
        if (check !== -1) {
            d.splice(check, 1);
        } else {
            d.push(index);
        }
        console.log("listIndex", list);
        setListIndex(d);
    };

    const checkIndex = (index) => {
        const d = [...listIndex];
        const check = listIndex.findIndex((item) => item === index);

        return check === -1 ? false : true;
    };

    const getVideo = (quizItem, quizIndex) => {
        const copy = cloneDeep(newQuizList);
        const index = copy?.chapters?.findIndex((item) => item.id === quizItem.id);
        console.log("test", index);
        const indexItem = copy.chapters[index];
        console.log("indexItem", indexItem);
        const returnItem = indexItem?.videos?.find(
            (item) => item.id === indexItem.quizList[quizIndex]?.relateVideos
        );
        return returnItem?.fileName || "";
    };

    const uploadData = () => {
        const copy = cloneDeep(newQuizList);
        const data = copy?.chapters?.map((item) => {
            const chapterId = item?.id;
            const quizDtoList = cloneDeep(item?.quizList);
            return {
                chapterId,
                quizDtoList,
            };
        });

        return data;
    };

    const putQuiz = async (next = true) => {
        await classesAPI.putClassQuiz(createId, {
            data: {
                newQuizDtoList: uploadData(),
            },
        })
            .then(res => {
                if(next == true){
                    navigate("/create/instructor message",{
                        state:{
                            createId:createId
                        }
                    })
                }
            })
    };
    const [openState, setOpenState] = useState(null);
    console.log("uploadData()", uploadData());

    useEffect(() => {
        setSubmit(true);
    }, []);

    console.log("newQuizList1", newQuizList);
    console.log("selectedata", selectedata);
    console.log("quizData", quizData);
    // @ts-ignore
    console.log("@chapterData",chapterData);
    console.log("@fold",foldIndex);
    return (
        <Container>
            {onPopup && (
                <Overlay filter={false}>
                    <Popup
                        headerText={"Create Chapter"}
                        onChange={onChangeTitle}
                        onChangeSubItem={onChangeCategory}
                        placeholder={"Category"}
                        subPlaceholder={"Chapter title"}
                        value={chapterTitle}
                        subItemValue={chapterCategory}
                        title={""}
                        desc={""}
                        buttonText={"Create"}
                        onClose={()=>{
                            setOnPopup(false);
                        }}
                        onClick={() => {
                            setChapterList(true, null, chapter);
                        }}
                    />
                </Overlay>
            )}

            <Contents>
                <h2
                    style={{
                        fontWeight: "700",
                        fontSize: 26,
                        marginBottom: 20,
                    }}
                ></h2>
                {getQuizList(selectedata?.id)?.map((quizItem, index) => {
                    console.log("@quizItem",quizItem);
                    if(quizItem?.category !== "CHAPTER"){
                        return <React.Fragment></React.Fragment>
                    }else{
                        return(
                            <FormItems
                                className={"on"}
                            >
                                <FormInner
                                    style={{
                                        paddingBottom: 0,
                                        background: "#fff",
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 2,
                                    }}
                                >
                                    <Row display={"flex"} style={{ marginBottom: 16 }}>
                                        {
                                            chapter?.length !== 1 &&
                                            <CloseButton
                                                onClick={()=>{
                                                    onClickDeleteChapter(quizItem?.id)
                                                }}
                                            >

                                                <CloseIcon />
                                            </CloseButton>
                                        }
                                        <Col style={{ width: "25%" }}>
                                            <FormBox>
                                                <dt>Category</dt>
                                                <dd>
                                                    <FormBoxItemWrap>
                                                        <li>
                                                            <FormItem
                                                                className={"category"}
                                                                style={{
                                                                    opacity:isEmpty(chapterItems?.chapters) ? 0.5 : 1,
                                                                    // pointerEvents:isEmpty(chapterItems?.chapters) ? "none" : "all"
                                                                    pointerEvents:"none"
                                                                }}
                                                            >
                                                                <DropdownMenu
                                                                    onClick={onClickDropDown}
                                                                    selected={
                                                                        // quizItem
                                                                        // @ts-ignore
                                                                        chapterData[index]?.category || ""
                                                                    }
                                                                    altText="Category"
                                                                    items={
                                                                        !isEmpty(chapterData)
                                                                            ? chapterData
                                                                            : [""]
                                                                    }
                                                                />
                                                            </FormItem>
                                                        </li>
                                                    </FormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                        <Col style={{ width: "100%", flex: 1, marginLeft: 15 }}>
                                            <FormBox
                                                style={{
                                                    pointerEvents:"none"
                                                }}
                                            >
                                                <dt>Chapter title</dt>
                                                <dd>
                                                    <FormBoxItemWrap>
                                                        <li>
                                                            <FormItem
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    placeholder="Chapter title"
                                                                    // value={selectedata?.chapterTitle || ""}
                                                                    value={  // @ts-ignore
                                                                        chapterData[index]?.chapterTitle}
                                                                    readOnly={true}
                                                                    disabled={true}
                                                                    style={{
                                                                        background:"#f5f5f5"
                                                                    }}
                                                                />
                                                                {/* <RemoveButton style={{ marginLeft: 21 }}>
                                                              <Remove />
                                                          </RemoveButton> */}
                                                            </FormItem>
                                                        </li>
                                                    </FormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                    </Row>
                                    <FormItemDivider />
                                </FormInner>

                                <InnerItems
                                    className={foldIndex.findIndex(item => quizItem?.id) !== -1 ? "on" : ""}
                                >
                                    {quizItem?.quizList?.map((item, quizIndex) => (
                                        <QuizInnerItems onChangeQuizItem={onChangeQuizItem}
                                                        openState={openState}
                                                        setOpenState={setOpenState}
                                                        removeQuiz={removeQuiz} getVideo={getVideo}
                                                        item={item} quizItem={quizItem} quizIndex={quizIndex} />
                                    ))}
                                </InnerItems>

                                {selectedata?.id && !isEmpty(chapterItems?.chapters) && (
                                    <AddButtonWrap
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: 20,
                                            marginBottom:10
                                        }}
                                    >
                                        <AddButton
                                            onClick={() => {
                                                addQuiz(quizItem?.id);
                                                // const c = [...foldIndex];
                                                // const check = c.findIndex(item => {
                                                //     return item === quizItem?.id;
                                                // })
                                                // if(check == -1){
                                                //     c.push(quizItem?.id)
                                                //     setFoldIndex(c);
                                                // }
                                                setOpenState({
                                                    id:quizItem?.id,
                                                    length:quizItem?.quizList?.length + 1
                                                })

                                            }}
                                        >
                                            <span>Add quiz</span>
                                        </AddButton>
                                    </AddButtonWrap>
                                )}
                                {/*<AddButtonWrap*/}
                                {/*    style={{*/}
                                {/*        width: "100%",*/}
                                {/*        display: "flex",*/}
                                {/*        justifyContent: "flex-end",*/}
                                {/*        marginTop: 20,*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*    <AddButton*/}
                                {/*        onClick={() => {*/}

                                {/*        }}*/}
                                {/*    >*/}
                                {/*        <span>Add quiz</span>*/}
                                {/*    </AddButton>*/}
                                {/*</AddButtonWrap>*/}
                            </FormItems>
                        )
                    }
                })}
                <AddChapter
                    // @ts-ignore
                    className={isEmpty(chapter.find(item => {
                        // @ts-ignore
                        return !isEmpty(item?.id)
                    })) ? "off" : ""}
                    onClick={(e) => {
                        const findItem = chapter.find(item => {
                            // @ts-ignore
                            return !isEmpty(item?.id)
                        })
                        console.log("@findItem",findItem);
                        e.stopPropagation();
                        // @ts-ignore
                        if(isEmpty(findItem)) {
                            setAlert({
                                isActive:true,
                                text:"Please create an additional chapter to proceed with the new chapter quiz.",
                                desc:"",
                                type:"info",
                                color:"blue",
                                time: 1300
                            })
                        }else {
                            setOnPopup(true);
                        }
                    }}
                >
                    <PlusIcon />
                    <span>Add chapter</span>
                </AddChapter>
            </Contents>

            <ButtonItems

                justifyContent={"flex-end"}
            >
                <Browse
                    className={"prev"}
                    onClick={()=>{
                        putQuiz(false)
                        navigate("/create/videos",{
                            state:{
                                createId:createId
                            }
                        })
                    }}
                    style={{ marginRight: 15, width: 100, height: 40 }}>
                    <span style={{ marginLeft: 0, }}>Previous</span>
                </Browse>
                <button
                    className={"continue on"}
                    onClick={() => {
                        putQuiz();
                    }}
                >Continue</button>
            </ButtonItems>
        </Container>
    );
};
export default Quiz;

const QuizInnerItems = ({quizItem, removeQuiz, onChangeQuizItem, getVideo, quizIndex,
                            openState, setOpenState, item}) => {
    const [fold, setFold] = useState(false);
    useEffect(() => {
        if(quizItem?.id == openState?.id && quizIndex + 1 == openState?.length){
            setFold(true)
        }
    }, [openState]);
    console.log("@openState",openState);
    return(
        <QuizItemsWrap>
            <QuizInner
                style={{
                    border:quizIndex == 0 && "none"
                }}
                className={fold ? "on" : ""}>
                <IconBox
                    className={`${fold ? "on" : ""} open`}
                    onClick={()=>{
                        setOpenState(null);
                        setFold(v => !v)
                    }}
                >
                    {
                        !fold ? <span>Open</span> :
                               <span>Close</span>
                    }
                    {
                        fold ? <EyeIcon/> : <EyeOpen/>
                    }
                </IconBox>
                <IconBox
                    className={`close`}
                    onClick={() => {

                        removeQuiz(quizItem?.id, quizIndex)
                    }}
                >
                    <CloseIcon />
                </IconBox>
                <h3
                    style={{ marginBottom: 15 }}
                >
                    Question {quizIndex + 1}
                </h3>

                <FormItem
                    style={{
                        width: "100%",
                        marginRight: 15,
                        marginBottom: 15,
                    }}
                >
                    <input
                        type="text"
                        value={item?.question}
                        placeholder="Enter a quiz question"
                        onChange={(e) => {
                            const value = e.target.value;
                            onChangeQuizItem(
                                quizItem.id,
                                quizIndex,
                                "question",
                                value
                            );
                        }}
                        maxLength={300}
                    />
                    <TextLength>{300 - item?.question?.length}</TextLength>
                </FormItem>

                <div className={"innerWrap"}>
                    {/*<FormItem*/}
                    {/*    style={{*/}
                    {/*        width: "100%",*/}
                    {/*        marginRight: 15,*/}
                    {/*        marginBottom: 15,*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <input*/}
                    {/*        type="text"*/}
                    {/*        value={item?.question}*/}
                    {/*        placeholder="Enter a quiz question"*/}
                    {/*        onChange={(e) => {*/}
                    {/*            const value = e.target.value;*/}
                    {/*            onChangeQuizItem(*/}
                    {/*                quizItem.id,*/}
                    {/*                quizIndex,*/}
                    {/*                "question",*/}
                    {/*                value*/}
                    {/*            );*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*    <TextLength>{300 - item?.question?.length}</TextLength>*/}
                    {/*</FormItem>*/}
                    {!isEmpty(quizItem?.videos) && (
                        <FormBox style={{ marginBottom: 20 }}>
                            <dt>Related Videos</dt>
                            <dd>
                                <FormBoxItemWrap>
                                    <li>
                                        <FormItem className={"related"}>
                                            <DropdownMenu
                                                altText="Select a related video lecture to help students answer
                                                                             this question."
                                                state={"id"}
                                                selected={getVideo(
                                                    quizItem,
                                                    quizIndex
                                                )}
                                                onClick={(
                                                    seleteItem,
                                                    state,
                                                    index,
                                                    item
                                                ) => {
                                                    onChangeQuizItem(
                                                        quizItem.id,
                                                        quizIndex,
                                                        "relateVideos",
                                                        item.id
                                                    );
                                                }}
                                                items={quizItem?.videos?.map(
                                                    (item) => {
                                                        return {
                                                            ...item,
                                                            dropdownItem:
                                                            item.fileName,
                                                        };
                                                    }
                                                )}
                                            />
                                        </FormItem>
                                    </li>
                                </FormBoxItemWrap>
                            </dd>
                        </FormBox>
                    )}
                    <h3 style={{ marginBottom: 15 }}>Answers</h3>
                    <FormItem
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            marginRight: 15,
                            marginBottom: 15,
                        }}
                    >
                        <CheckBox
                            onClick={() => {
                                console.log("item.ccorrect4", item.correct4);
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "correct1",
                                    !item.correct1
                                );
                            }}
                            style={{ opacity: 1 }}
                            className={item.correct1 ? "on" : ""}
                        >
                            <div>
                                <Check />
                            </div>
                        </CheckBox>{" "}
                        <input
                            type="text"
                            value={item.answer1}
                            placeholder="Enter a quiz answer1"
                            onChange={(e) => {
                                const value = e.target.value;
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "answer1",
                                    value
                                );
                            }}
                        />
                        <TextLength>{300 - item.answer1?.length}</TextLength>
                    </FormItem>
                    <FormItem
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            marginRight: 15,
                            marginBottom: 15,
                        }}
                    >
                        <CheckBox style={{ opacity: 0 }}>
                            <div />
                        </CheckBox>{" "}
                        <span style={{ width: 98, marginRight: 16 }}>
                                                Explanation
                                            </span>
                        <input
                            type="text"
                            value={item.explanation1}
                            placeholder="Enter a quiz explanation1"
                            onChange={(e) => {
                                const value = e.target.value;
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "explanation1",
                                    value
                                );
                            }}
                        />
                        <TextLength>{300 - item.explanation1?.length}</TextLength>
                    </FormItem>

                    <FormItem
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            marginRight: 15,
                            marginBottom: 15,
                        }}
                    >
                        <CheckBox
                            onClick={() => {
                                console.log("item.ccorrect4", item.correct4);
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "correct2",
                                    !item.correct2
                                );
                            }}
                            style={{ opacity: 1 }}
                            className={item.correct2 ? "on" : ""}
                        >
                            <div>
                                <Check />
                            </div>
                        </CheckBox>{" "}
                        <input
                            type="text"
                            value={item.answer2}
                            placeholder="Enter a quiz answer2"
                            onChange={(e) => {
                                const value = e.target.value;
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "answer2",
                                    value
                                );
                            }}
                        />
                        <TextLength>{300 - item.answer2?.length}</TextLength>
                    </FormItem>
                    <FormItem
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            marginRight: 15,
                            marginBottom: 15,
                        }}
                    >
                        <CheckBox style={{ opacity: 0 }}>
                            <div />
                        </CheckBox>{" "}
                        <span style={{ width: 98, marginRight: 16 }}>
                                                Explanation
                                            </span>
                        <input
                            type="text"
                            value={item.explanation2}
                            placeholder="Enter a quiz explanation2"
                            onChange={(e) => {
                                const value = e.target.value;
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "explanation2",
                                    value
                                );
                            }}
                        />
                        <TextLength>{300 - item.explanation2?.length}</TextLength>
                    </FormItem>

                    <FormItem
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            marginRight: 15,
                            marginBottom: 15,
                        }}
                    >
                        <CheckBox
                            onClick={() => {
                                console.log("item.ccorrect4", item.correct4);
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "correct3",
                                    !item.correct3
                                );
                            }}
                            style={{ opacity: 1 }}
                            className={item.correct3 ? "on" : ""}
                        >
                            <div>
                                <Check />
                            </div>
                        </CheckBox>{" "}
                        <input
                            type="text"
                            value={item.answer3}
                            placeholder="Enter a quiz answer3"
                            onChange={(e) => {
                                const value = e.target.value;
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "answer3",
                                    value
                                );
                            }}
                        />
                        <TextLength>{300 - item.answer3?.length}</TextLength>
                    </FormItem>
                    <FormItem
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            marginRight: 15,
                            marginBottom: 15,
                        }}
                    >
                        <CheckBox style={{ opacity: 0 }}>
                            <div />
                        </CheckBox>{" "}
                        <span style={{ width: 98, marginRight: 16 }}>
                                                Explanation
                                            </span>
                        <input
                            type="text"
                            value={item.explanation3}
                            placeholder="Enter a quiz explanation3"
                            onChange={(e) => {
                                const value = e.target.value;
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "explanation3",
                                    value
                                );
                            }}
                        />
                        <TextLength>{300 - item.explanation3?.length}</TextLength>
                    </FormItem>

                    <FormItem
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            marginRight: 15,
                            marginBottom: 15,
                        }}
                    >
                        <CheckBox
                            onClick={() => {
                                console.log("item.ccorrect4", item.correct4);
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "correct4",
                                    !item.correct4
                                );
                            }}
                            style={{ opacity: 1 }}
                            className={item.correct4 ? "on" : ""}
                        >
                            <div>
                                <Check />
                            </div>
                        </CheckBox>{" "}
                        <input
                            type="text"
                            value={item.answer4}
                            placeholder="Enter a quiz answer4"
                            onChange={(e) => {
                                const value = e.target.value;
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "answer4",
                                    value
                                );
                            }}
                        />
                        <TextLength>{300 - item.answer4?.length}</TextLength>
                    </FormItem>
                    <FormItem
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            marginRight: 15,
                            marginBottom: 15,
                        }}
                    >
                        <CheckBox
                            onClick={() => {
                                console.log("item.ccorrect4", item.correct4);

                            }}
                            style={{ opacity: 0 }}
                            className={item.correct4 ? "on" : ""}
                        >
                            <div>
                                <Check />
                            </div>
                        </CheckBox>{" "}
                        <span style={{ width: 98, marginRight: 16 }}>
                                                Explanation
                                            </span>
                        <input
                            type="text"
                            value={item.explanation4}
                            placeholder="Enter a quiz explanation4"
                            onChange={(e) => {
                                const value = e.target.value;
                                onChangeQuizItem(
                                    quizItem.id,
                                    quizIndex,
                                    "explanation4",
                                    value
                                );
                            }}
                        />
                        <TextLength>{300 - item.explanation4?.length}</TextLength>
                    </FormItem>
                </div>
            </QuizInner>
        </QuizItemsWrap>
    )
}

const Container = styled.div`
    //overflow-y: scroll;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    //
    //&::-webkit-scrollbar {
    //    width: 0;
    //}
    //
    //&::-webkit-scrollbar-thumb {
    //    background-color: transparent;
    //}
`;

const Contents = styled.div`
    padding: 20px;
    width: 100%;
    overflow: hidden;
`;

const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 15px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
    }
`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
    @media screen and (max-width: 768px) {
        width: 100%!important;
        margin-left: 0!important;
    }
`;
const Divider = styled.div`
    width: calc(140%);
    transform: translateX(-20%);
    height: 1px;
    background: #333;
    opacity: 0.3;
`;
const FormBox = styled.dl`
    > dt {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        /* opacity: 0.8; */
        margin-bottom: 8px;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
    
    .related{
        .dropdownBtn{
            background: #fff!important;
        }
    }
    .dropdownBtn{
        background: #f5f5f5;
    }
`;

const FormItem = styled.div`
    position: relative;
    &.category{
        svg{
            display: none!important;
        }
    }
    > input[type="text"],
    select,
    textarea {
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;
const InnerItems = styled.div`
    //height: 430px;
    // height: 200px;
    &.on{}
    overflow-y: auto;
    //padding-bottom: 20px;
    scrollbar-width: thin;
    scrollbar-color: #33333320 transparent;
    @media screen and (max-width: 768px) {
        //height: 330px;
    }
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`
const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
`;

const ThumbnailTitle = styled.h5`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    line-height: 22px;
`;

const ThumbnailUpload = styled.div`
    width: 100%;
    height: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #000;
        opacity: 0.5;
        content: "";
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    > li {
        margin: 0 4px;
    }
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 20px 20px 30px 20px;
    display: flex;
    justify-content: space-between;
    border-top: #33333360 solid 1px;
    
    button {
        &.continue{
            font-family: Europa-Regular;
            font-size: 18px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;
            border: solid 1px #ddd;
        }
        transition: all 0.2s;
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #fff;
        border-radius: 6px;
        background: #ddd;
        pointer-events: none;
        border: solid 1px #333;
        &.on{
            background: #333;
            color: #fff;
            pointer-events: all;
            border: solid 1px #333;
            &:hover{
                background: #fff;
                color: #333;
            }
        }
    }
`;

const FormItems = styled.div`
    transition: all 0.3s;
    border: solid 1px #33333360;
    border-radius: 15px;
    overflow: hidden;
    height: 200px;
    //height: 800px;
    &.on{
        height: auto;
    }
    @media screen and (max-width: 768px) {
        height: 300px;
    }
    position: relative;
    margin-bottom: 20px;
    box-shadow: 0px 0px 6px 0px #33333329;
    //overflow-y: scroll;
    //scrollbar-width: thin;
    //scrollbar-color: transparent transparent;
    //
    //&::-webkit-scrollbar {
    //    width: 0;
    //}
    //
    //&::-webkit-scrollbar-thumb {
    //    background-color: transparent;
    //}
`;
const FormInner = styled.div`
    padding: 15px 15px 10px 15px;
    position: relative;
    transition: all 0.3s;
    height: 100%;
`;
const FormItemDivider = styled.div`
    width: 300%;
    transform: translateX(-20%);
    height: 1px;
    background: #33333360;
`;
const QuizItemsWrap = styled.div`
    //padding: 0px 15px 0px 15px;
    transition: all 0.2s;
    h2 {
        color: "#000";
        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 400;
    }
`;
const VideoItems = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
`;
const CheckBox = styled.div`
    display: flex;
    margin-right: 13px;
    align-items: center;
    transition: all 0.2s;
    &.on {
        transition: all 0.2s;

        & > div {
            transition: all 0.2s;
            border: solid 1px #ddc160;
            background: #ddc160;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    span {
        padding-top: 2px;
        font-size: 16px;
        color: #212529;
    }
    div {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: solid 1px rgba(51, 51, 51, 0.3);
    }
`;
const Browse = styled.div`
    position: relative;
    transition: all 0.2s;
    cursor: pointer;
    height: 48px;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;
    flex: 1;
    width: 100%;
    max-width: 120px;
    &.prev{
        width: 100px;
        max-width: 100px;
        padding: 0!important;
    }
    &.add{
        width: 100px;
        max-width: 100px;
        padding: 0!important;
    }
    &:hover{
        background: #333;
        border-color: #333;
        span{
            color: #fff!important;
        }

        svg{
            path{
                fill: #fff!important;
            }
        }
        span{
            color: #fff;

        }
    }
    @media screen and (max-width: 768px) {
        width: 100%!important;
        min-width: 100%;
        max-width: 100%;
        min-height: 46px;
        &.prev{
            min-width: 95px;
            max-width: 95px;
            min-height: 40px;
        }
        &.add{
            min-width: 95px;
            max-width: 95px;
            min-height: 40px;
            height: 40px;
        }
    }
    span {
        margin-left: 10px;
        font-size: 18px;
        color: #333;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    svg{
        width: 16px;
        height: 16px;
        path{
            fill: #333!important;
        }
    }
    input {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0;
        z-index: 3;
    }
`;
const CloseButton = styled.div`
    background: #333;
    position: absolute;
    right: 0;
    top: 0;
    width: 51px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.eye{
        left: 50%;
        transform: translate(-50%);
        svg{
            path{
                fill: #fff;
            }
        }
    }
`;
const RemoveButton = styled.div``;

const AddButton = styled.div`
    height: 40px;
    cursor: pointer;
    background: #fff;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #33333360;
    transition: all 0.2s;
    &:hover{
        background: #333;
        color: #fff;
    }

    span {
        font-size: 20px;
    }
`;

const AddChapter = styled.div`
    background: #333;
    display: flex;
    align-items: center;
    width: 160px;
    height: 40px;
    justify-content: center;
    border-radius: 5px;
    margin-top: 20px;
    cursor: pointer;
    border: solid 1px #333;
    transition: all 0.2s;
    &:hover{
        background: #fff;
        span{
            color: #333;
        }
        svg{
            path{
                fill: #333;
            }
        }
    }
    &.off{
        background: #ddd;
        opacity: 0.7;
        border: solid 1px #ddd;
    }
    span {
        color: #fff;
        font-size: 18px;
        margin-left: 10px;
        font-weight: 400;
    }
`;

const QuizInner = styled.div`
    position: relative;
    border-top: dashed 1px #33333380;
    //box-shadow: 0px 0px 6px rgba(51, 51, 51, 0.6);

    //border-radius: 15px;
    transition: all 0.3s;
    padding: 20px;
    height: auto;
    overflow: hidden;
    height: 160px;

    h3 {
        cursor: pointer;
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        /* opacity: 0.8; */
    }
    .innerWrap {
        opacity: 0;
    }
    &.on {
        height: 780px;
        & > div {
            opacity: 1;
        }
    }
`;
const IconBox = styled.div`
    position: absolute;
    //bottom: 0;
    left: 50%;
    background: #333!important;
    padding: 0!important;
    transform: translateX(-50%);
    cursor: pointer;
    z-index: 999;
    //width: 100%;
    display: flex;
    top:0;
    bottom: calc(100%);
    min-width: 51px;
    height: 25px;
    &.open{
        width: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 11px!important;
        border-radius: 0px 0px 5px 5px;
        &:hover{
            span{
                transform: scale(1.1);
            }
        }
        span{
            color: #fff;
        }
    }
    &.close{
        left: 100%;
        transform: translateX(-100%);
    }
    span{
        font-family: Europa-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        text-align: left;
    }
    //&.on{
    //    top:0;
    //    bottom: calc(100% - 20px);
    //    svg{
    //        transform: rotate(180deg) scale(1.5);
    //        margin-right: 5px;
    //    }
    //}
    justify-content: center;
    align-items: center;
    svg{
        path{
            fill: #fff;
        }
    }
    svg{
        //transform: scale(1.5);
        //padding-right: 3px;
    }
`;
const AddButtonWrap = styled.div`
    position: sticky;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 20px;
    z-index: 99999;

    bottom: 0;
    background: #fff;
`;

const Transcript = styled.div`
    h3 {
        margin-top: 20px;
        margin-bottom: 14px;
        font-size: 26px;
        font-weight: 700;
    }
`;